<template>
  <div class="home_box">
    <div class="en_box" v-if="$i18n.language == 'en'">
      <img src="../assets/images/contact_en.jpg" alt="" />
    </div>
    <div class="contact_page" v-else>
      <div class="banner">
        <img src="../assets/images/contact_banner.png" alt="" />
      </div>
      <div class="btn_box">
        <div class="btn_body">
          <div class="btns">
            <div
              class="btn"
              :class="tabIndex === item ? 'btn_act' : ''"
              v-for="(item, index) in btns"
              :key="index"
              @click="changeTab(item)"
            >
              {{ $t(item) }}
            </div>
          </div>
          <div class="goback">
            <span @click="goback()">{{ $t("contact.backToHome") }}</span> >
            <span> {{ $t("contact.contactUs") }}</span>
          </div>
        </div>
      </div>
      <div class="lxwm_box" @click="jumpPage()">
        <img src="../assets/images/rlzp_img.png" alt="" />
      </div>
      <div class="lxwm_box">
        <img src="../assets/images/xzhz_img.png" alt="" />
      </div>
      <!-- <div class="lxwm_box" v-show="tabIndex==='项目投资'"></div> -->
      <!-- 	<div class="lxwm_box">
				<img src="../assets/images/tsjy_img.png" alt="" />
			</div> -->
      <div class="lxwm_box">
        <img src="../assets/images/address_img.png" alt="" />
      </div>
      <!-- <div class="lxwm_box" v-show="tabIndex==='宣传推广'"></div> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "contact",
  data() {
    return {
      tabIndex: "",
      btns: [],
    };
  },
  methods: {
    goback() {
      this.$router.push("/Home");
    },
    changeTab(item) {
      this.tabIndex = item;
    },
    //跳转招聘页面
    jumpPage() {
      window.open("https://jcaregroup.zhiye.com/");
    },
  },
};
</script>
<style lang="scss" scoped>
.home_box {
  width: 100%;
  height: 100%;
  .en_box {
    width: 100%;
    height: 100%;
    margin-top: -110px;
    img {
      width: 100%;
      height: auto;
    }
  }
}
.contact_page {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  .banner {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }

  .btn_box {
    width: 100%;
    height: 64px;
    background-color: #f0f1f5;

    .btn_body {
      width: 100%;
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btns {
        width: 50%;
        height: 64px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .btn {
          width: auto;
          padding: 5px 10px;
          box-sizing: border-box;
          background-color: rgba(255, 255, 255, 1);
          margin-right: 15px;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;

          &:hover {
            transition: all 0.3s;
            box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
          }
        }

        .btn_act {
          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
        }
      }

      .goback {
        width: auto;
        height: 64px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        span {
          cursor: pointer;

          &:last-child {
            font-weight: bold;
          }
        }
      }
    }
  }

  .lxwm_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
